import styled from 'styled-components';

import { spacingUnits } from '@pegasus/ui-constants/spacing';
import { Screen, screenFrom } from '@pegasus/ui-constants/breakpoints';
import { Container } from '@pegasus/ui-components/legacy/layout';

export const Body = styled(Container)`
    display: flex;
    flex: 1 0 auto;
`;
export const Wrapper = styled.section`
    display: flex;
    flex-direction: row;
    height: auto;
    width: 100%;
`;

export const ChildrenWrapper = styled.section`
    padding: ${spacingUnits(6)} 0;
    flex-grow: 1;
    width: 100%;

    ${screenFrom(Screen.desktop)} {
        margin-left: ${spacingUnits(4)};
        padding-bottom: ${spacingUnits(10)};
        width: 75%;
    }
`;

export const FixedButtonsWrapper = styled.footer`
    position: fixed;
    bottom: 10px;
    right: 10px;
    display: flex;
    flex-direction: column;
    align-content: space-between;
    z-index: 10;
`;

export const FlashMessageContainerWrapper = styled.section`
    position: fixed;
    width: 100%;
    z-index: 1000;
`;
